import React from "react";
import ModalV2 from "../Modal-V2";
import { CONFIRM, ERROR, INPUT, INFO } from "../Modal-V2/constants";
import "./Modal.scss";

/**
 * Legacy Modal wrapper for backward compatibility.
 * This component wraps Modal-V2 to maintain compatibility with existing code
 * that uses the old Modal API.
 *
 * @deprecated Use Modal-V2 directly instead
 * 
 * @param {Object} props
 * @param {String|JSX.Element=} props.content
 * @param {Boolean} props.open
 * @param {String=} props.title
 * @param {Object[]=} props.list
 * @param {String=} props.primaryLabel
 * @param {String=} props.header
 * @param {()=>void=} props.primaryCallback
 * @param {Boolean=} props.enablePrimaryCallback
 * @param {String=} props.modalType
 * @param {String=} props.secondaryLabel
 * @param {()=>void=} props.secondaryCallback
 * @param {Boolean=} props.successIcon
 * @param {Boolean=} props.showCloseButton
 */

export default function Modal({
	content,
	open,
	title,
	list,
	header = "",
	modalType = INFO,
	primaryLabel,
	primaryCallback,
	enablePrimaryCallback,
	secondaryLabel,
	secondaryCallback,
	successIcon = false,
	showCloseButton = true,
}) {
	// Map old enablePrimaryCallback to new disablePrimaryBtn (inverted logic)
	const disablePrimaryBtn = enablePrimaryCallback !== undefined ? !enablePrimaryCallback : false;

	// Determine closeModal callback
	const closeModal = showCloseButton ? (secondaryCallback || primaryCallback) : undefined;

	// Render content with list if provided
	const renderContent = () => {
		if (!content && !list) return null;
		
		return (
			<>
				{header && <div style={{margin: "5px 0"}}><b>{header}</b></div>}
				<div>{content}</div>
				{list && (
					<ul style={{ textAlign: "left", margin: "10px 0" }}>
						{list.map((item, index) => (
							<li key={index}>{item}</li>
						))}
					</ul>
				)}
			</>
		);
	};

	return (
		<ModalV2
			modalType={modalType}
			showModal={open}
			title={title}
			primaryLabel={primaryLabel}
			primaryCallback={primaryCallback}
			secondaryLabel={secondaryLabel}
			secondaryCallback={secondaryCallback}
			closeModal={closeModal}
			// disablePrimaryBtn={disablePrimaryBtn}
			icon={successIcon ? "/assets/img/modal_icons/success.webp" : undefined}
		>
			{renderContent()}
		</ModalV2>
	);
}